import * as React from "react";
import * as yup from "yup";

import { Link } from "src/library/components/Link";
import {
  Form,
  IFormField
} from "src/library/components/Forms";
import Grid from "src/library/components/Hedron";

interface ResetPasswordFormProps {
  errorMessage: string | null;
  loggingIn: boolean;
  onSubmit: (newPassword: string) => void;
}

const resetPasswordFormFields: IFormField[] = [
  {
    type: "input",
    name: "newPassword",
    inputType: "password",
    label: "New Password",
    placeholder: "New Password",
    validation: yup
      .string()
      .min(1)
      .required("New Password is required")
  },
  {
    type: "input",
    name: "confirmPassword",
    inputType: "password",
    label: "Confirm Password",
    placeholder: "Confirm Password",
    validation: yup
      .string()
      .min(1)
      .required("Confirm Password is required")
  }
];

export const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  errorMessage, loggingIn, onSubmit
}) => {
  return (
    <Form
      error={errorMessage}
      submitting={loggingIn}
      fields={resetPasswordFormFields}
      onSubmit={({ newPassword }) => onSubmit(newPassword)}
      submitButtonText="New Password"
      submitButtonAlignment="center"
    >
      <Grid.Bounds direction="horizontal">
        <Grid.Box shiftRight>
          <Link to="/forgot-password">
            Forgot Password
          </Link>
        </Grid.Box>
      </Grid.Bounds>
    </Form>
  );
};
